export default "__VITE_ASSET__52601e80__"